/**
 * Extranet data tables
 * @class
 */
class ExtranetTable {
  tables: NodeListOf<Element>;

  constructor(private selector:string) {
  }

  /**
   * Init tables
   */
  public init () {
    if(this.selector) {
      this.tables = document.querySelectorAll(`.${this.selector} table`);
      this.tables.length > 0 ? this._addListeners() : [];
    }
  }

  /**
   * Add listeners to buttons
   */
  private _addListeners() {
    this.tables.forEach((table) => {
      table.querySelectorAll('.js-show-all-row-data').forEach((button) => {
        button.addEventListener('click', () => {
          button.closest('tr').querySelectorAll('td').forEach((td) => {
            td.classList.add('visible-on-mobile');
            button.remove();
          });
        });
      });
    });
  }
}

export { ExtranetTable };
